export default __webpack_public_path__ + "static/media/pg-49.c8d34529.jpg";